import { Input } from '@/components/ui/input';
import type { MetadataSchemaField } from '@/types/metadata.types';

interface DateFieldProps {
  field: MetadataSchemaField;
  value: unknown;
  onChange: (value: unknown) => void;
  error?: string;
  disabled?: boolean;
  includeTime?: boolean;
}

export default function DateField({
  field,
  value,
  onChange,
  error,
  disabled,
  includeTime = false,
}: DateFieldProps) {
  // Convert ISO string to input format if needed
  const formatValue = (val: unknown): string => {
    if (!val) return '';
    if (typeof val === 'string') {
      // If it's an ISO string, convert to local date format
      if (val.includes('T')) {
        const date = new Date(val);
        if (includeTime) {
          // Format: YYYY-MM-DDTHH:mm
          return date.toISOString().slice(0, 16);
        }
        // Format: YYYY-MM-DD
        return date.toISOString().slice(0, 10);
      }
      return val;
    }
    return '';
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (!val) {
      onChange(null);
    } else if (includeTime) {
      // Convert to ISO string
      onChange(new Date(val).toISOString());
    } else {
      // Keep as date string (YYYY-MM-DD)
      onChange(val);
    }
  };

  return (
    <Input
      id={field.fieldKey}
      type={includeTime ? 'datetime-local' : 'date'}
      placeholder={field.placeholder || ''}
      value={formatValue(value)}
      onChange={handleChange}
      disabled={disabled}
      className={error ? 'border-destructive' : ''}
    />
  );
}
